import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DescDevExpreportAuthService {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    if ((localStorage.getItem('userType') === '2') &&
      ((localStorage.getItem('roleId') === '1') || (localStorage.getItem('roleId') === '2')
      || (localStorage.getItem('roleId') === '3') || (localStorage.getItem('roleId') === '4')
      || (localStorage.getItem('roleId') === '11') || (localStorage.getItem('roleId') === '12'))) {
      return true;
    } else {
      this.router.navigate(['/userview/dashboard']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/AUTHGAURD/desc-dev-expreport-auth.service.ts